export class Orders {
    http;
    constructor(http) {
        this.http = http;
    }
    getOrders() {
        return this.http.get(`/api/orders`).json();
    }
}
